var _style, _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuscando(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.73 141.73",
    style: {
      enableBackground: "new 0 0 141.73 141.73"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000104675551670253086200000012078342352154011011_);}\n\t.st2{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -656.2845,
    y1: -385.096,
    x2: -656.2845,
    y2: -327.097,
    gradientTransform: "matrix(1 0 0 1 725.842 427.0438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E94E1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9B233"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.2,99.95H23.92c-3.29,0-5.96-2.67-5.96-5.96V47.91c0-3.29,2.67-5.96,5.96-5.96h91.28 c3.29,0,5.96,2.67,5.96,5.96v46.07C121.16,97.28,118.49,99.95,115.2,99.95z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061468879046477401240000005722513826056823955_",
    gradientUnits: "userSpaceOnUse",
    x1: 799.2136,
    y1: -169.4625,
    x2: 799.2136,
    y2: -115.4635,
    gradientTransform: "matrix(-1 0 0 -1 868.7711 -71.5156)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E94E1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9B233"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061468879046477401240000005722513826056823955_)"
    },
    d: "M25.92,43.95h87.28 c3.29,0,5.96,2.67,5.96,5.96v42.07c0,3.29-2.67,5.96-5.96,5.96H25.92c-3.29,0-5.96-2.67-5.96-5.96V49.91 C19.96,46.62,22.62,43.95,25.92,43.95z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.44,81.66h4.53c2.98,0,3.94,1.23,3.94,2.62s-0.92,2.42-2.45,2.79c0.97,0.34,1.65,1.06,1.65,2.18 c0,1.89-1.57,3.32-4.95,3.32h-5.66L27.44,81.66z M30.4,90.13c1.04,0,1.68-0.47,1.68-1.15c0-0.56-0.45-0.86-1.34-0.86h-2.09 l-0.54,2.01H30.4z M31.28,86c1.08,0,1.65-0.42,1.65-1.11c0-0.5-0.39-0.81-1.31-0.81h-1.88L29.24,86H31.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.23,90.22c0-0.45,0.09-0.98,0.23-1.51l1.23-4.58h2.96l-1.18,4.41c-0.06,0.22-0.11,0.5-0.11,0.69 c0,0.56,0.33,0.89,0.95,0.89c0.83,0,1.31-0.56,1.56-1.53l1.2-4.46h2.96l-2.24,8.43h-2.96l0.25-0.97c-0.58,0.61-1.4,1.15-2.4,1.15 C37.15,92.75,36.23,91.77,36.23,90.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.09,91.3l1.46-1.73c0.81,0.73,1.95,1.14,2.8,1.14c0.5,0,0.75-0.2,0.75-0.51c0-0.3-0.33-0.47-1.15-0.79 c-1.34-0.53-2.37-1.12-2.37-2.46c0-1.68,1.36-2.99,3.68-2.99c1.53,0,2.88,0.56,3.65,1.18l-1.42,1.78 c-0.73-0.54-1.62-0.9-2.38-0.9c-0.48,0-0.73,0.19-0.73,0.48c0,0.28,0.3,0.45,1.17,0.79c1.22,0.48,2.35,1.06,2.35,2.46 c0,1.62-1.21,3.02-3.65,3.02C47.64,92.76,46.1,92.2,45.09,91.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.06,89.07c0-2.84,2.26-5.11,5.06-5.11c1.96,0,3.13,1.01,3.58,2.31l-2.32,1.2 c-0.28-0.65-0.69-1.06-1.45-1.06c-1.12,0-2.03,1.23-2.03,2.51c0,0.86,0.56,1.4,1.29,1.4c0.62,0,1.08-0.26,1.59-0.78l1.81,1.57 c-0.86,1-1.92,1.65-3.6,1.65C55.73,92.76,54.06,91.35,54.06,89.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.33,90.44c0-1.85,1.48-2.98,3.71-2.98c0.76,0,1.46,0.12,2.13,0.33l0.03-0.11 c0.03-0.14,0.08-0.31,0.08-0.51c0-0.54-0.42-0.9-1.45-0.9c-0.79,0-1.68,0.19-2.27,0.42l-0.42-2.15c0.89-0.31,2.1-0.51,3.32-0.51 c2.52,0,3.75,1,3.75,2.68c0,0.39-0.06,0.79-0.17,1.21l-1.25,4.64h-2.91l0.23-0.9c-0.72,0.67-1.45,1.08-2.43,1.08 C63.29,92.73,62.33,91.84,62.33,90.44z M67.78,89.38l0.08-0.28c-0.33-0.11-0.7-0.19-1.11-0.19c-0.94,0-1.54,0.45-1.54,1.22 c0,0.48,0.34,0.78,0.84,0.78C66.82,90.91,67.55,90.24,67.78,89.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.54,84.13h2.96l-0.26,0.97c0.58-0.61,1.42-1.15,2.42-1.15c1.53,0,2.45,0.97,2.45,2.52 c0,0.45-0.11,0.98-0.25,1.51l-1.21,4.58h-2.96l1.18-4.41c0.06-0.22,0.09-0.5,0.09-0.69c0-0.56-0.33-0.89-0.93-0.89 c-0.83,0-1.31,0.56-1.57,1.53l-1.2,4.46h-2.96L73.54,84.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.86,89.29c0-3.02,2.12-5.34,4.53-5.34c1.26,0,2.04,0.55,2.55,1.34l1.09-4.1H93l-3.04,11.37H87l0.25-0.89 c-0.67,0.64-1.48,1.08-2.4,1.08C83.18,92.75,81.86,91.47,81.86,89.29z M88.37,87.9c0-0.9-0.61-1.5-1.46-1.5 c-1.11,0-2.06,1.08-2.06,2.41c0,0.9,0.58,1.48,1.43,1.48C87.42,90.3,88.37,89.18,88.37,87.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M92.36,88.84c0-2.54,2.13-4.89,4.95-4.89c2.59,0,4.14,1.7,4.14,3.91c0,2.56-2.13,4.91-4.97,4.91 C93.91,92.76,92.36,91.07,92.36,88.84z M98.62,87.96c0-0.95-0.59-1.56-1.46-1.56c-1.17,0-1.96,1.23-1.96,2.32 c0,0.97,0.59,1.57,1.46,1.57C97.82,90.3,98.62,89.07,98.62,87.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.26,89.52h3.08l-0.83,3.04h-3.07L102.26,89.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.96,89.52h3.08l-0.83,3.04h-3.07L106.96,89.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.67,89.52h3.08l-0.83,3.04h-3.07L111.67,89.52z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.33,51.89c0.53,0,0.96-0.43,0.96-0.96v-3.29c0-0.53-0.43-0.96-0.96-0.96H60.78 c-0.53,0-0.96,0.43-0.96,0.96v3.29c0,0.53,0.43,0.96,0.96,0.96h0.27v6.15c0,0-0.28,1.78,1.42,2.51c1.7,0.74,2.26,1.13,2.26,1.13 l-2.49,1.36c0,0-1.21,0.54-1.21,2.37c0,1.2,0,4.27,0,6.01h-0.25c-0.53,0-0.96,0.43-0.96,0.96v3.29c0,0.53,0.43,0.96,0.96,0.96 h17.55c0.53,0,0.96-0.43,0.96-0.96v-3.29c0-0.53-0.43-0.96-0.96-0.96h-0.38c0-1.74,0-4.82,0-6.01c0-1.82-1.21-2.37-1.21-2.37 l-2.49-1.36c0,0,0.57-0.4,2.26-1.13c1.7-0.74,1.42-2.51,1.42-2.51v-6.15H78.33z M61.43,48.44h16.25v1.69H61.43V48.44z  M77.68,74.87H61.43v-1.69h16.25V74.87z M76.24,58.69l-5.26,3l5.32,3v6.74h-13.6v-6.74l5.32-3l-5.26-3v-6.8h13.49V58.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.68,55.16H69.5h-5.19v2.88l4.39,2.21v4.6c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8v-4.6l4.39-2.21 V55.16z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "69.5,66.52 64.31,69.04 64.31,70.37 69.5,70.37 74.68,70.37 74.68,69.04  "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuscando);
export default __webpack_public_path__ + "static/media/Buscando.0b34db52a6809cfaaad04ceeb4b9395f.svg";
export { ForwardRef as ReactComponent };